import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardHeader from './card-header';


export default function Card({ className, children, title, defaultClasses, ...props }) {
  return (
    <div className="card-wrapper">
      <div {...props} className={classNames(className, defaultClasses, 'card')}>
        { title &&
          <CardHeader>{title}</CardHeader>
        }
        {children}
      </div>
    </div>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.node,
  defaultClasses: PropTypes.string
};
